module.exports = __webpack_public_path__ + "static_pc/img/23.8c681e39.png";